import React, {useMemo, useState} from 'react';
import {Box, FormControl, InputLabel, MenuItem, Select} from '@mui/material';
import {Delete, NearMe} from '@mui/icons-material';

import {ResourceContextProvider} from 'components/record/ResourceContext';
import List from 'components/list/List';
import {DateField, ListField} from 'components/list/Fields';
import ActionMenu from 'components/list/actionMenu/ActionMenu';
import ActionMenuItemDelete from 'components/list/actionMenu/ActionMenuItemDelete';
import BulkMergeDevices from 'components/forms/BulkMergeDevices';
import BulkMapCompetitorsToUser from 'components/forms/BulkMapCompetitorsToUser';
import DeviceEventsField from './DeviceEventsField';

const UNIT_FILTER_OPTIONS = [
  {value: 'all', label: 'All devices'},
  {value: 'units', label: 'Units only'},
  {value: 'non-units', label: 'Non-units only'}
];

const AllDevicesPage = () => {
  const [unitFilter, setUnitFilter] = useState('all');

  const unitVariable = useMemo(() => {
    if (unitFilter === 'units') {
      return true;
    }
    if (unitFilter === 'non-units') {
      return false;
    }
    return undefined;
  }, [unitFilter]);

  const unitParams = useMemo(() => (unitVariable !== undefined ? {unit: unitVariable} : {} as Record<string, boolean>), [unitVariable]);

  return (
    <div className="container-fluid">
      <ResourceContextProvider resource="AllDevice" params={unitParams}>
        <List
          bulkOptions
          hidePagination
          title="All Devices"
          avatar={<NearMe />}
          bulkActions={
            <Box gap={2} display="flex">
              <BulkMergeDevices />
              <BulkMapCompetitorsToUser />
            </Box>
          }
          listFilters={
            <Box sx={{mb: 2, maxWidth: 240}}>
              <FormControl fullWidth size="small">
                <InputLabel id="device-unit-filter-label">Units</InputLabel>
                <Select
                  labelId="device-unit-filter-label"
                  id="device-unit-filter"
                  value={unitFilter}
                  label="Units"
                  onChange={(event) => setUnitFilter(event.target.value)}
                >
                  {UNIT_FILTER_OPTIONS.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          }
        >
          <ListField source="name" label="Device ID" />
          <ListField source="unit" label="Unit" transform={(value) => <>{value ? 'Yes' : 'No'}</>} />
          <ListField source="battery" label="Battery" />
          <DateField source="last" label="Last check" format="YYYY-MM-DD HH:mm:ss" />
          <ListField source="liveloxPersonId" label="Livelox person ID" />
          <DeviceEventsField source="eventCount" label="Events" />
          <ListField source="user.firstName" label="User" />
          <ActionMenu label="" align="right" variant="standalone">
            <ActionMenuItemDelete
              permission="device:admin"
              label="Remove"
              icon={<Delete fontSize="small" />}
              confirmContent="Are you sure you want to remove this device?"
            />
          </ActionMenu>
        </List>
      </ResourceContextProvider>
    </div>
  );
};

export default AllDevicesPage;
